import Modal, {ModalProps} from 'react-bootstrap/Modal';
import React, {useEffect, useState} from "react";
import axios from "axios";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import {useTranslation} from "react-i18next";
import {toast} from "react-custom-alert";

const UserDestroyConfirmation = ({ uID, ...props }: ModalProps)  => {
    const { t } = useTranslation();
    const handleConfirm = () => {

        const payload = {
            uID
        };

        axios.post('/api/user-destroy', payload, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(response => {
            //alert(response);
            window.location.reload();
        }).catch(error => {
            console.log(error);
            toast.error(error.response.data.message);
        });
    };

    return (

        <Modal
            {...props}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body style={{height:'200px'}}>
                <h4>{t('captions.warning')}</h4> <br />
                Sei sicuro di voler cancellere questo utente?<br />
                L'operazione non è reversibile!
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn_1 green" onClick={handleConfirm}>{t('captions.confirm')}</button>
                <button type="button" className="btn_1 yellow" onClick={props.onHide}>{t('captions.cancel')}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default UserDestroyConfirmation;
